import React from 'react'

import OrderForm from './components/OderForm'
import OrderList from './components/OderList'

const Orders: React.FC = () => {
  return (
    <div className="row">
      <OrderForm />
      <OrderList />
    </div>
  )
}

export default Orders
